.rowActionsTrigger {
	padding: 0;
	border: none;
	background: none;
	font: inherit;
	line-height: 1;
	color: var(--color-primary-outline);
	cursor: pointer;
}

.rowActionsTrigger:focus-visible {
	outline: 2px solid var(--color-primary);
	outline-offset: 2px;
}
